import { frontTypes, types } from "../../../variables";

const getRusQuestionType = (engType) => {
  const typeIndex = types.findIndex((type) => type === engType);
  return frontTypes[typeIndex];
}

export default getRusQuestionType;